export const BidManagementSkeleton = () => {
  return (
    <div className="flex divide-x divide-gray-200 px-2">
      {/* Left Section - Campaign Details & Bid Creation */}
      <div className="w-2/5 pr-6 py-0">
        <div className="h-6 w-32 bg-gray-200 dark:bg-neutral-700 rounded animate-pulse mb-4" />
        <div className="space-y-6">
          <div className="grid grid-cols-2 gap-4">
            <div>
              <div className="h-4 w-24 bg-gray-200 dark:bg-neutral-700 rounded animate-pulse mb-2" />
              <div className="h-6 w-full bg-gray-200 dark:bg-neutral-700 rounded animate-pulse" />
            </div>
            <div>
              <div className="h-4 w-24 bg-gray-200 dark:bg-neutral-700 rounded animate-pulse mb-2" />
              <div className="h-6 w-full bg-gray-200 dark:bg-neutral-700 rounded animate-pulse" />
            </div>
          </div>

          <div className="grid grid-cols-2 gap-4">
            <div>
              <div className="h-4 w-24 bg-gray-200 dark:bg-neutral-700 rounded animate-pulse mb-2" />
              <div className="h-6 w-full bg-gray-200 dark:bg-neutral-700 rounded animate-pulse" />
            </div>
            <div>
              <div className="h-4 w-24 bg-gray-200 dark:bg-neutral-700 rounded animate-pulse mb-2" />
              <div className="h-6 w-full bg-gray-200 dark:bg-neutral-700 rounded animate-pulse" />
            </div>
          </div>

          <div>
            <div className="h-4 w-24 bg-gray-200 dark:bg-neutral-700 rounded animate-pulse mb-2" />
            <div className="h-10 w-full bg-gray-200 dark:bg-neutral-700 rounded animate-pulse" />
          </div>

          <div className="flex justify-between gap-3 w-full">
            <div className="h-10 w-full bg-gray-200 dark:bg-neutral-700 rounded animate-pulse" />
            <div className="h-10 w-full bg-gray-200 dark:bg-neutral-700 rounded animate-pulse" />
          </div>
        </div>
      </div>

      {/* Right Section - History */}
      <div className="w-3/5 bg-gray-50 dark:bg-neutral-800 pl-6 py-0">
        <div className="h-6 w-32 bg-gray-200 dark:bg-neutral-700 rounded animate-pulse mb-4" />
        <div className="space-y-3 h-full overflow-y-auto pr-3">
          {[...Array(7)].map((_, index) => (
            <div key={index} className="flex items-start bg-gray-50 dark:bg-neutral-800 rounded-lg">
              <div className="flex-grow">
                <div className="flex items-center justify-between mb-2">
                  <div className="flex items-center gap-2">
                    <div className="h-5 w-5 bg-gray-200 dark:bg-neutral-700 rounded animate-pulse" />
                    <div className="h-4 w-16 bg-gray-200 dark:bg-neutral-700 rounded animate-pulse" />
                    <div className="h-5 w-5 bg-gray-200 dark:bg-neutral-700 rounded animate-pulse" />
                    <div className="h-4 w-16 bg-gray-200 dark:bg-neutral-700 rounded animate-pulse" />
                    <div className="h-4 w-4 bg-gray-200 dark:bg-neutral-700 rounded animate-pulse" />
                    <div className="h-5 w-5 bg-gray-200 dark:bg-neutral-700 rounded animate-pulse" />
                    <div className="h-4 w-24 bg-gray-200 dark:bg-neutral-700 rounded animate-pulse" />
                  </div>
                  <div className="flex items-center">
                    <div className="h-4 w-4 bg-gray-200 dark:bg-neutral-700 rounded animate-pulse mr-1" />
                    <div className="h-4 w-20 bg-gray-200 dark:bg-neutral-700 rounded animate-pulse" />
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
